// extracted by mini-css-extract-plugin
var _1 = "CelsiusClaimStyles-module__balances-header___fh5oo";
var _2 = "CelsiusClaimStyles-module__balances-header-columns___Eu88J";
var _3 = "CelsiusClaimStyles-module__balances-table___R0lgb";
var _4 = "CelsiusClaimStyles-module__balances-table-wrapper___agrgM";
var _5 = "CelsiusClaimStyles-module__balances-header___fh5oo";
var _6 = "CelsiusClaimStyles-module__balances-header-columns___Eu88J";
var _7 = "CelsiusClaimStyles-module__balances-table___R0lgb";
var _8 = "CelsiusClaimStyles-module__balances-table-wrapper___agrgM";
var _9 = "CelsiusClaimStyles-module__celsius-claim-page___D818C";
var _a = "CelsiusClaimStyles-module__celsius-claim-page-content___dXJUw";
var _b = "CelsiusClaimStyles-module__celsius-claim-page___D818C";
var _c = "CelsiusClaimStyles-module__celsius-claim-page-content___dXJUw";
var _d = "CelsiusClaimStyles-module__header___Ox0qj";
export { _1 as "balances-header", _2 as "balances-header-columns", _3 as "balances-table", _4 as "balances-table-wrapper", _5 as "balancesHeader", _6 as "balancesHeaderColumns", _7 as "balancesTable", _8 as "balancesTableWrapper", _9 as "celsius-claim-page", _a as "celsius-claim-page-content", _b as "celsiusClaimPage", _c as "celsiusClaimPageContent", _d as "header" }
